/* **********************************************
 Begin jquery.nested-menus.js
 ********************************************** */

(function($) {

	$(document).ready(function() {

		function heightSetter () {
			var highest = 0;
			$('.nested-menu .current').each(function(){
				if(highest < $(this).height()) {
					highest = $(this).height();
				}
			});

			$('.nested-menu').css ( {
				height: highest
			});

		}

		// initially set height
		heightSetter();

		// orientationchange/resize --> reset height
		$(window).bind('resize',function(){
			heightSetter();
		});

		$(document).on('click', '.nested-back', function (e) {
			e.stopPropagation();
			e.preventDefault();

			var that = $(this);

			that.parent('ul').offsetParent().css ( {
					left: '0%',
					'z-index' : 1
				}
			);

			that.parent('ul').css ( {
					opacity: '0',
					'z-index' : 0
				}
			);

			that.parent('ul').removeClass('current');
			that.parent('ul').offsetParent().addClass('current');

			var prevHeight = that.parent('ul').offsetParent().outerHeight();

			$(".nested-menu").css({
				height: prevHeight
			});
            $(this).closest('.collapse').trigger('sizeChanged'); // listener on common.js - hijackScroll
			$('html, body').animate({ scrollTop: 0});
		});

		$(document).on('click', '.nested-parent', function (e) {
			e.stopPropagation();
			e.preventDefault();

			var that = $(this);

			that.parents('ul').css ( {
					left: '-100%',
					'z-index' : 1
				}
			);

			that.next('ul').css ( {
					opacity: '1',
					'z-index' : 1
				}
			);

			var nextHeight = that.next('ul').outerHeight();

			that.parents('ul').removeClass('current');
			that.next('ul').addClass('current');

			$(".nested-menu").css({
				height: nextHeight
			});
            $(this).closest('.collapse').trigger('sizeChanged'); // listener on common.js - hijackScroll
			$('html, body').animate({ scrollTop: 0});


		});

		$('#accordion-top').on('shown.bs.collapse', heightSetter);

	});


})(jQuery);



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.nested-menus.js